import React, { useState, useEffect, useMemo } from "react";

// others
import dayjs from "dayjs";
import Parkings from "./components/Parkings";
import { configKeys } from "./components/utils";
import { Loading } from "./components/modalContent";
import { useDispatch, useSelector } from "react-redux";
import { getKycDetailsService } from "./ducks/services";
import { useParams, useLocation, Link } from "react-router-dom";
import DashboardLayout from "../../molecules/DashboardLayout";
import { disableEditButton, disablePaymentSchedule } from "./components/utils";
import { DocList, LeaseTerms, RenewalTerms, TenantDetails, PaymentSchedule } from "./components/view";
import {
  getConfigData,
  getLandlordUsers,
  getBookingDetail,
  clearBookingForm,
  getBookingUnitDetail,
  getTemplateDocuments,
  getParkingBays,
} from "./ducks/actions";
import { Modal, Collapse, ActionHeader, BookingDetailsCard as Card } from "./components";

import { maintenanceService } from "../../../configs/constants";
import axios from "axios";
import { hasTorRules } from "./utils";
import TorLedger from "./components/view/TorLedger";
import { Checklist, Notes, SplitLayout } from "../../organism";
import { useGetOrganization } from "../../../api/v1";

import { ModalHeader } from "./ModalHeader";
import { useBillingSchedulePreview } from "./components/Commercial/add-plan/api/useBillingSchedulePreview";

import PropertyAdminAlert from "./components/PropertyAdminAlert";
import { useTorSchedulePreview } from "./components/Commercial/add-plan/api/useTorSchedulePreview";

let initialState = {
  load: false,
  visible: false,
  kycDetails: [],
  isKyc: true,
  attachDoc: {},
  modalPayload: {
    iKey: "",
    title: "",
    open: false,
    extraText: "",
  },
};

function ViewBooking() {
  // hooks initialization
  const { state } = useLocation();
  const dispatch: any = useDispatch();
  const { leaseId = "" } = useParams();
  const { organization } = useGetOrganization();

  const typeOfRenewal = useParams();
  // states
  const [{ load, isKyc, visible, modalPayload, kycDetails, attachDoc }, setState] = useState(initialState);
  let newRenewalType = typeOfRenewal["*"];
  let isMonthlyBillingBreakdown = organization?.monthlyBillingBreakdownAndTorSeparateInvoicing;

  // redux states
  let { bookingDetails, bookingForm } = useSelector((state: any) => state.newBooking);
  const breakdown = bookingDetails?.commercialBillingScheduleBreakdown || [];
  const { yearOptions, selectedYear, selectYear, selectedSchedule, showYearOption } =
    useBillingSchedulePreview(breakdown);

  const isCommercialBooking = bookingDetails?.propertyDetails?.usagesType === "Commercial";
  const isTorScheduleModalOpen = modalPayload?.open === true && modalPayload?.iKey === "52";

  const {
    data: torSchedule,
    isLoading: isTorScheduleLoading,
    yearOptions: torYearOptions,
    setYear: torSetYear,
    isSuccess: isTorScheduleSuccess,
    year: torScheduleYear,
  } = useTorSchedulePreview({
    leaseId,
    initialYear: 1,
    isTorSchedule: isCommercialBooking && isTorScheduleModalOpen,
  });

  let isRenewalToRenewal =
    (bookingDetails?.leaseStatus === "active" || bookingDetails.leaseStatus === "lease_expired") &&
    bookingDetails?.renewalStatus === "active" &&
    newRenewalType === "renewalTorenewal";
  // redux states

  let { refresh_renwal } = useSelector((state: any) => state.newBooking);

  //
  let isRenewal =
    (state?.renewal && state?.renewal) ||
    bookingDetails?.leaseType === "renewal" ||
    bookingDetails?.leaseType === "extension";

  const updateState = (state: {}) => setState((prevState: any) => ({ ...prevState, ...state }));

  useEffect(() => {
    if (leaseId) dispatch(getBookingDetail(leaseId));
    dispatch(getConfigData(configKeys));
    dispatch(getTemplateDocuments());

    return () => {
      dispatch(clearBookingForm());
    };
  }, [refresh_renwal]);

  useEffect(() => {
    const unitId = state?.selectedUnit?.unitId || bookingDetails?.unitId;
    const propertyId = state?.selectedProperty?.propertyId || bookingDetails?.propertyId;

    dispatch(getLandlordUsers(propertyId));
    dispatch(getParkingBays({ propertyId: propertyId }));

    if (Object.keys(bookingDetails).length > 0 && !bookingDetails?.parentLeaseTerms?.leaseStartDate && isRenewal) {
      const parentLeaseTerms = { ...bookingDetails.leaseTerms };
      bookingDetails["parentLeaseTerms"] = {
        ...bookingDetails.parentLeaseTerms,
        ...parentLeaseTerms,
      };
    }

    if (unitId) {
      dispatch(getBookingUnitDetail(unitId));
      getKycDetails(unitId); // for bug:
    }
    if (
      (Object.keys(bookingDetails).length > 0 &&
        (bookingDetails?.leaseStatus === "active" || bookingDetails?.leaseStatus === "lease_expired") &&
        isRenewal &&
        !bookingDetails?.renewalStatus) ||
      isRenewalToRenewal
    ) {
      const leaseTerms = {
        ...bookingDetails.leaseTerms,
        ...{
          leaseStartDate: dayjs(bookingDetails.leaseTerms.leaseEndDate).add(1, "day").toISOString(),
          leaseEndDate: dayjs(bookingDetails.leaseTerms.leaseEndDate).add(1, "year").toISOString(),
        },
      };

      bookingDetails["leaseTerms"] = {
        ...bookingDetails.leaseTerms,
        ...leaseTerms,
      };
    }
  }, [bookingDetails]);

  //  for user story 8455

  const [renewalFormConform, setRenewalFormConfirm] = useState<Boolean>(false);

  const handleEditPress = (key: string, renewalConform = false) => {
    let payload: any = { ...modalPayload };

    setRenewalFormConfirm(renewalConform);

    switch (key) {
      case "1":
        payload = {
          iKey: "1",
          title: "Tenant Details",
          // extraText: "Enter an email address to look for an existing tenant or add a new one.",
          kycDetails, //added for bug: 7498,
        };
        break;
      case "2":
        payload = {
          iKey: "2",
          extraText: "",
          title: "Lease Terms",
        };
        break;
      case "3":
        payload = {
          iKey: "3",
          extraText: "",
          title: "Edit Payment Schedule",
        };
        break;
      case "4":
        payload = {
          iKey: "4",
          width: "700px",
          extraText: "",
          title: renewalConform
            ? "Confirm Renewal Terms"
            : bookingDetails?.bookingTerms?.renewalAmount
              ? "Edit Renewal Terms"
              : "Create Renewal Terms",
        };
        break;
      case "5":
        payload = {
          iKey: "5",
          extraText: "",
          title: "Add Payment",
          width: "80%",
        };
        break;
      case "6":
        payload = {
          iKey: "6",
          extraText: "",
          width: "450px",
          title: "Request Documents",
        };
        break;
      case "7":
        payload = {
          iKey: "7",
          extraText: "",
          width: "80%",
          className: "generate-modal",
          title: "Generate Document from Template",
        };
        break;
      case "8":
        payload = {
          iKey: "8",
          width: "80%",
          title: "Change Payment Plan",
          extraText: "",
          //   "You can add a new payment plan, edit, or disable an existing payment plan. If you add or edit a payment plan, you\nneed to send an approval request.",
        };
        break;
      case "11":
        payload = {
          iKey: "11",
          width: "80%",
          extraText: "",
          title: "Change History",
        };
        break;
      case "15":
        payload = {
          iKey: "15",
          width: "600px",
          extraText: "",
          title: "Attach Docs",
          attachDoc,
        };
        break;
      case "32":
        payload = {
          iKey: "32",
          width: "650px",
          extraText: "",
          title: "TOR Rules",
          className: "mb-0",
          // attachDoc,
        };
        break;
      case "30":
        payload = {
          iKey: "30",
          width: "650px",
          extraText: "",
          title: "Add TOR Report",
          // attachDoc,
        };
        break;
      case "40":
        payload = {
          iKey: "40",
          width: "1000px",
          extraText: "",
          title: "Lease Configuration",
          // attachDoc,
        };
        break;
      case "custom-fields":
        payload = {
          iKey: "custom-fields",
          width: "50%",
          extraText: "",
          title: "Custom Fields",
        };
        break;
      case "financial-dimensions":
        payload = {
          iKey: "financial-dimensions",
          width: "50%",
          extraText: "",
          title: "Financial Dimensions",
        };
        break;
      case "50":
        payload = {
          iKey: "50",
          width: "1400px",
          extraText: "",
          title: "Additional Terms",
          isSignedByBoth: hasBothEjariSignatures(bookingDetails),
        };
        break;
      case "51":
        payload = {
          iKey: "51",
          width: "79rem",
          extraText: "",
          title: (
            <ModalHeader
              title="Billing Schedule Preview"
              value={selectedYear || 1}
              options={showYearOption ? yearOptions : []}
              onChange={(val) => selectYear(val)}
            />
          ),
        };
        break;

      case "52":
        payload = {
          iKey: "52",
          width: "79rem",
          extraText: "",
          title: "TOR Schedule",
        };
        break;
    }

    updateState({ modalPayload: { ...payload, ...{ open: true } } });
  };

  const resolvedModalTitle = useMemo(() => {
    if (modalPayload?.iKey === "52" && modalPayload?.open) {
      return (
        <ModalHeader
          title="TOR Schedule"
          value={torScheduleYear ?? 1}
          options={isTorScheduleSuccess ? torYearOptions : []}
          onChange={(val) => torSetYear(val)}
          isLoading={isTorScheduleLoading}
        />
      );
    }

    return modalPayload?.title;
  }, [
    modalPayload?.iKey,
    modalPayload?.open,
    modalPayload?.title,
    torScheduleYear,
    torYearOptions,
    isTorScheduleSuccess,
    isTorScheduleLoading,
    torSetYear,
  ]);

  const getKycDetails = async (unitId: string) => {
    try {
      const response = await getKycDetailsService(unitId);
      if (response?.length > 0) updateState({ isKyc: false, kycDetails: response });
      else updateState({ isKyc: false, kycDetails: [] });
    } catch (error) {
      updateState({ isKyc: false, kycDetails: [] });
    }
  };

  const disable = disableEditButton(bookingDetails, isRenewal);

  const disableDuringRenewal = isRenewal || isKyc || disable;

  const disableParkings =
    bookingDetails?.leaseStatus == "sent_for_lease_approval"
      ? true
      : bookingDetails?.leaseStatus == "sent_for_booking_approval"
        ? true
        : false;

  const [gracePeriodDays, setGracePriodDays] = useState(null);

  const getOrgByID = useMemo(
    () => async () => {
      if (!bookingDetails?.orgId) return; // Prevent unnecessary calls

      try {
        const data = await axios.get(`${maintenanceService}/organization/${bookingDetails?.orgId}`);
        setGracePriodDays(data?.data?.result?.dayForPaynowbtnBeforeDueDate);
      } catch (e) {
        console.log("Err", e);
      }
    },
    [bookingDetails?.orgId],
  ); // Memoize based on orgId change

  useEffect(() => {
    bookingDetails && bookingDetails?.isAutoPayActive && getOrgByID();
  }, [bookingDetails?.orgId]);

  let isleaseTypeTor = bookingDetails?.torType
    ? hasTorRules(bookingDetails?.torType)
    : hasTorRules(bookingForm?.torType);

  const hasBothEjariSignatures = (bookingDetails?: any): boolean => {
    type DocumentItem = {
      documentName?: string;
      [key: string]: any;
    };
    const ejariDocs: DocumentItem[] =
      bookingDetails?.ejari?.ejariDocuments?.map((doc: DocumentItem) => ({
        ...doc,
        isLeasingDoc: true,
      })) || [];

    const additionalDocs: DocumentItem[] = bookingDetails?.documents || [];

    const allDocs = [...ejariDocs, ...additionalDocs];

    const tenantSigned = allDocs.some((item) => item.documentName === "LTV_tenantSignedEjariContract");

    const landlordSigned = allDocs.some((item) => item.documentName === "LTV_landlordSignedEjariContract");

    return tenantSigned && landlordSigned;
  };

  return (
    <DashboardLayout load={load} className="bf-main-content">
      <Loading visible={visible} />

      <ActionHeader
        label=""
        renewal={isRenewal}
        booking={bookingDetails}
        parentState={updateState}
        actions={true}
        handleEditPress={handleEditPress}
      />
      <SplitLayout>
        <SplitLayout.Content style={{ flex: 1 }}>
          <PropertyAdminAlert
            isRenewal={isRenewal}
            propertyId={bookingDetails?.propertyId}
            adminName={bookingDetails?.adminManager?.name}
          />

          <Card
            booking={bookingDetails}
            renewal={isRenewal}
            stateRenewal={isRenewal}
            handleChangeHistory={handleEditPress}
            isRenewalToRenewal={isRenewalToRenewal}
          />

          <Collapse
            key="1"
            iKey="1"
            header="Tenant Details"
            modalKey={modalPayload?.iKey}
            disable={disableDuringRenewal}
            handleEditPress={handleEditPress}
          >
            <TenantDetails kycDetails={kycDetails} />
          </Collapse>

          <Collapse
            key="2"
            iKey="2"
            header="Lease Terms"
            modalKey={modalPayload?.iKey}
            disable={disableDuringRenewal}
            disableAdditionalTermsBtn={hasBothEjariSignatures(bookingDetails)}
            handleEditPress={handleEditPress}
            showAdditionalTermsBtn={true}
          >
            <LeaseTerms
              contractNumber={bookingDetails?.ejari?.contractNumber}
              booking={bookingDetails}
              renewal={isRenewal}
            />
          </Collapse>

          {(isRenewal || newRenewalType === "renewalTorenewal") && (
            <Collapse
              key="4"
              iKey="4"
              disable={
                bookingDetails?.renewalStatus === "sent_for_approval" ||
                bookingDetails?.renewalStatus === "renewal_accepted"
              }
              header="Renewal Terms"
              modalKey={modalPayload?.iKey}
              handleEditPress={handleEditPress}
            >
              <RenewalTerms newRenewalType={newRenewalType} booking={bookingDetails} />
            </Collapse>
          )}

          <Collapse
            key="3"
            iKey="3"
            header="Payment Schedule"
            modalKey={modalPayload?.iKey}
            handleEditPress={handleEditPress}
            disable={disablePaymentSchedule(bookingDetails)}
            renewal={isRenewal || bookingDetails?.propertyDetails?.usagesType == "Commercial"} // to
            isMonthlyBillingBreakdown={isMonthlyBillingBreakdown}
          >
            <PaymentSchedule
              gracePeriodDays={gracePeriodDays}
              newRenewalType={newRenewalType}
              renewal={isRenewal}
              booking={bookingDetails}
            />
          </Collapse>

          {bookingDetails?.propertyDetails?.usagesType == "Commercial" && isleaseTypeTor && (
            <Collapse
              key="32"
              iKey="32"
              header="Turnover Ledger"
              modalKey={modalPayload?.iKey}
              handleEditPress={handleEditPress}
              disable={disablePaymentSchedule(bookingDetails)}
              isMonthlyBillingBreakdown={isMonthlyBillingBreakdown}
            >
              <TorLedger />
            </Collapse>
          )}
          <Collapse key="6" iKey="6" disable={disable} header="Parkings" modalKey={modalPayload?.iKey}>
            <Parkings
              data={bookingDetails?.parkings}
              update={true}
              disable={disableParkings}
              noOfFreeParkingSlots={bookingDetails?.leaseTerms?.noOfFreeParkingSlots}
            />
          </Collapse>
          <Collapse key="5" iKey="5" header="Documents" disable={disable}>
            <DocList
              booking={bookingDetails}
              handleGenerate={handleEditPress}
              parentState={updateState}
              disable={disable}
            />
          </Collapse>

          <Modal
            className="bd-modal"
            renewal={isRenewal}
            updateState={updateState}
            modalPayload={modalPayload}
            modalTitle={resolvedModalTitle}
            setRenewalFormConfirm={setRenewalFormConfirm}
            renewalFormConform={renewalFormConform}
            breakdownData={selectedSchedule}
            torScheduleData={torSchedule}
            loading={isTorScheduleLoading}
          />
        </SplitLayout.Content>

        <SplitLayout.Sider
          width="24%"
          className="ds-layout-sider"
          collapsible
          breakpoint="lg"
          collapsedWidth={0}
          trigger={null}
        >
          {organization?.enableChecklist && <Checklist />}
          {organization?.enableNotes && <Notes />}
        </SplitLayout.Sider>
      </SplitLayout>
    </DashboardLayout>
  );
}

export default ViewBooking;
